import Vue from 'vue'
import { firestorePlugin } from 'vuefire'
import { rtdbPlugin } from 'vuefire'

import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/auth'
import 'firebase/analytics'
import 'firebase/functions'

Vue.use(firestorePlugin)
Vue.use(rtdbPlugin)

const firebaseConfig = {
    apiKey: "AIzaSyDm8lN1HlDFmUCQjMd3ByIZdcRZD5MUKG8",
    authDomain: "one-expo.firebaseapp.com",
    databaseURL: "https://one-expo.firebaseio.com",
    projectId: "one-expo",
    storageBucket: "one-expo.appspot.com",
    messagingSenderId: "1059332033054",
    appId: "1:1059332033054:web:61521e683eed5315f9fc0f",
    measurementId: "G-HH1J7MFQV7"
};

firebase.initializeApp(firebaseConfig)
firebase.analytics();

export const projectId = firebase.app().options.authDomain.split('.')[0]

export const firestore = firebase.firestore()

//const { Timestamp, GeoPoint } = firebase.firestore
//export { Timestamp, GeoPoint }

export const rtdb = firebase.database()
export const RTDB_TIMESTAMP = firebase.database.ServerValue.TIMESTAMP

export const storage = firebase.storage()

export const auth = firebase.auth()

export const functions = firebase.functions()
